import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/lib/auth';
import { supabase } from '@/lib/supabase';

export const currentUserProfileQueryKey = (userId: string | null) =>
  ['current-user-profile', userId] as const;

/** Profile row from public.users for the signed-in user. */
export function useCurrentUserProfile() {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  return useQuery({
    queryKey: currentUserProfileQueryKey(userId),
    enabled: Boolean(userId),
    queryFn: async (): Promise<{
      id: string;
      name: string | null;
      email: string;
      phone: string | null;
    }> => {
      const { data, error } = await supabase
        .from('users')
        .select('id, name, email, phone')
        .eq('id', userId!)
        .single();
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
